import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, style, animate, transition, query, stagger, keyframes, state, group } from '@angular/animations';
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";

declare var $: any;

@Component({
	selector: 'app-case-practice-team-main',
	animations: [
		// 页面载入动画效果
		trigger('casePracticeTeamMainIntroAnimation', [
			transition('* => *', [
				query('img.casePracticeTeamMain', animate(0, style({
					opacity: 0.1
				}))),
				query('img.casePracticeTeamMain', stagger('200ms', [animate('200ms', style({
					opacity: 1
				}))])),
			])
		]),
		// 选项滑入滑出效果
		trigger('optionWrapAnimation', [
			state('hideOptionWrap', style({
				transform: 'translate(-200%)',
				opacity: 0
			})),
			state('showOptionWrap', style({
				transform: 'translate(0%)',
				opacity: 1
			})),
			transition('hideOptionWrap => showOptionWrap', animate('600ms', keyframes([
				style({
					transform: 'translate(-100%)',
					opacity: 0.1
				}),
				style({
					transform: 'translate(-80%)',
					opacity: 0.1
				}),
				style({
					transform: 'translate(-60%)',
					opacity: 0.3
				}),
				style({
					transform: 'translate(-50%)',
					opacity: 0.4
				}),
				style({
					transform: 'translate(-40%)',
					opacity: 0.5
				}),
				style({
					transform: 'translate(-30%)',
					opacity: 0.55
				}),
				style({
					transform: 'translate(-20%)',
					opacity: 0.6
				}),
				style({
					transform: 'translate(-10%)',
					opacity: 0.8
				}),
				style({
					transform: 'translate(0%)',
					opacity: 1
				})
			])))
		]),
		// 导师滑入滑出效果
		trigger('chatBoxTeacherAnimation', [
			state('hideTeacher', style({
				transform: 'translate(-300%)',
				opacity: 0
			})),
			state('showTeacher', style({
				transform: 'translate(0%)',
				opacity: 1
			})),
			transition('hideTeacher => showTeacher', animate('750ms', keyframes([
				style({
					transform: 'translate(-100%)',
					opacity: 0.1
				}),
				style({
					transform: 'translate(-80%)',
					opacity: 0.1
				}),
				style({
					transform: 'translate(-60%)',
					opacity: 0.3
				}),
				style({
					transform: 'translate(-50%)',
					opacity: 0.4
				}),
				style({
					transform: 'translate(-40%)',
					opacity: 0.5
				}),
				style({
					transform: 'translate(-30%)',
					opacity: 0.55
				}),
				style({
					transform: 'translate(-20%)',
					opacity: 0.6
				}),
				style({
					transform: 'translate(-10%)',
					opacity: 0.8
				}),
				style({
					transform: 'translate(0%)',
					opacity: 1
				})
			]))),
			transition('showTeacher => hideTeacher', animate('200ms', keyframes([
				style({
					opacity: 1
				}),
				style({
					opacity: 0.3
				}),
				style({
					opacity: 0.2
				}),
				style({
					opacity: 0.15
				}),
				style({
					opacity: 0.1
				}),
				style({
					opacity: 0
				})
			])))
		]),
		// 提示滑入滑出效果
		trigger('tipBoxAnimation', [
			state('hideTipBox', style({
				transform: 'translate(-300%)'
			})),
			state('showTipBox', style({
				transform: 'translate(0%)'
			})),
			transition('hideTipBox => showTipBox', animate('200ms', keyframes([
				style({
					transform: 'translate(-100%)',
					opacity: 0.2
				}),
				style({
					transform: 'translate(-80%)',
					opacity: 0.5
				}),
				style({
					transform: 'translate(-60%)',
					opacity: 1
				}),
				style({
					transform: 'translate(-40%)',
					opacity: 1
				}),
				style({
					transform: 'translate(-20%)',
					opacity: 1
				}),
				style({
					transform: 'translate(0%)',
					opacity: 1
				})
			])))
		]),
		// 场景回放滑入滑出效果
		trigger('reviewBoxAnimation', [
			state('hideReviewBox', style({
				transform: 'scale(0.1, 0.1)',
				opacity: 0
			})),
			state('showReviewBox', style({
				transform: 'scale(1, 1)',
				opacity: 1
			})),
			transition('hideReviewBox => showReviewBox', animate('200ms', keyframes([
				style({
					transform: 'scale(0.1, 0.1)',
					opacity: 0.1
				}),
				style({
					transform: 'scale(0.2, 0.2)',
					opacity: 0.2
				}),
				style({
					transform: 'scale(0.3, 0.3)',
					opacity: 0.3
				}),
				style({
					transform: 'scale(0.4, 0.4)',
					opacity: 0.4
				}),
				style({
					transform: 'scale(0.5, 0.5)',
					opacity: 0.5
				}),
				style({
					transform: 'scale(0.6, 0.6)',
					opacity: 0.6
				}),
				style({
					transform: 'scale(0.7, 0.7)',
					opacity: 0.7
				}),
				style({
					transform: 'scale(0.8, 0.8)',
					opacity: 0.8
				}),
				style({
					transform: 'scale(0.9, 0.9)',
					opacity: 0.9
				}),
				style({
					transform: 'scale(1, 1)',
					opacity: 1
				})
			]))),
			transition('showReviewBox => hideReviewBox', animate('200ms', keyframes([
				style({
					opacity: 1
				}),
				style({
					opacity: 0
				})
			])))
		])
	],
	templateUrl: './case-practice-team-main.component.html',
	styleUrls: ['./case-practice-team-main.component.css', ]
})

export class CasePracticeTeamMainComponent implements OnInit, AfterViewInit {

	typeId: number;
	step: number;
	decisionTree: any;

	node: any;
	subNode: any;
	conversation: any;
	currentRole: string;
	nextRole: string;
	oldRole: string;
	currentComment: string;
	conversationHistory: any;
	currentNode: any;
	nextNode: any;
	msgCharacter: number; //计算逐出文字
	msgTimeout: any; //逐出文字timeout
	optionWrapShow: boolean; // 显示选项
	optionClick: boolean; // 监听长按选项行为
	optionOnClick: boolean; // 监听用户是否按键
	optionClickTimeout: any; // 长按选项timeout
	chatBoxTeacherShow: boolean; // 显示点评
	tipBoxShow: boolean; // 显示提示
	reviewBoxShow: boolean; // 显示场景回顾

	clickable: boolean; // 控制屏幕可否点击
	firstOptionGuide: boolean; // 第一次option的时候是否要提示
	guideStatus: boolean;

	questionsSubmit: any;
	answersSubmit: any;
	multiExerciseMetaId: any;
	learningPathId: any;
	practiceMetaId: any;
  assetsRoute: string = "../../assets";
  type: string;

	constructor(private commonService: CommonService,
		private apiService: ApiService,
		private route: ActivatedRoute,
		private router: Router) {}

	ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.route.queryParams.subscribe(queryParams=>{
      this.type=queryParams['type']
    })
		this.route.params.subscribe(params => {
			this.typeId = params['typeId'];
			this.multiExerciseMetaId = params['multiExerciseMetaId'];
			this.learningPathId = params['learningPathId'];
			this.practiceMetaId = params['practiceMetaId'];
		});


		this.step = 0;

		this.msgCharacter = 0;
		this.msgTimeout = null;
		this.optionWrapShow = false;
		this.optionClick = false;
		this.optionOnClick = false;
		this.optionClickTimeout = null;
		this.chatBoxTeacherShow = false;
		this.tipBoxShow = false;
		this.reviewBoxShow = false;
		this.firstOptionGuide = true;

		this.conversationHistory = [];
		this.questionsSubmit = [];
		this.answersSubmit = [];

		this.apiService.ajax({
			'type': 'get',
			'url': '/api/multi/' + this.typeId
		}).subscribe(result => {
			this.decisionTree = result;
			this.node = 1;
			this.subNode = 0;
			this.currentNode = this.decisionTree[this.node];
			this.currentNode.option = this.currentNode.option.sort(function(){
	        	return 0.5 - Math.random();
	    	});
			this.apiService.ajax({
				'type': 'get',
				'url': '/sr/onceino/602',
				'data': {}
			}).subscribe(result => {
				if(!result) {
					this.guideStatus = true;
					this.apiService.ajax({
						'type': 'post',
						'url': '/sr/onceino/602',
						'data': {}
					}).subscribe();
				} else {
					this.guideStatus = false;
					// this.screenClick();
				}
				this.clickable = true;
			});
		});

		this.apiService.ajax({
			'type': 'get',
			'url': '/sr/onceino/601',
			'data': {}
		}).subscribe(result => {
			if(result) {
				this.firstOptionGuide = false;
			}
		});
	}


	ngAfterViewInit() {
		this.commonService.initPage({
			'backgroundColor': 'white'
		});
		document.oncontextmenu = function(e) {
			e.preventDefault();
		}
	}

	screenClick() {

		let _this = this;
		/*  逻辑
		step 0: 初始化, 用户再次点击屏幕, => step 1.5
		step 1: 显示对话, 逐字输出, 再次点击 => step 1.5, 如果对话完结出现选项 => step 2
		step 1.5: 展示所有文字, 并且 => step 1
		step 2: 选择选项 => step 3, 显示我的
		step 3: 选项后重新跳入动画, 再次点击 => step 3.5
		step 3.5: 展示所有文字, 获取新内容, 再次点击 => step 1
		    角色
		旁白: 没有对话框, 文字
		人物: 淡入, 人物可以多个
		点评: 滑入, 导师
		*/
		if(this.clickable) {
			this.msgCharacter = 0;
			if(this.step == 0) {
				this.clickable = false;
				this.step = 1.5;
				$('#allPeople').fadeOut(0);
				$('#notice').fadeOut(0);
				$('#nextStep').fadeOut(0);
				this.setCurrentComment();
				setTimeout(function() {
					// 显示人物
					if(_this.currentRole.indexOf("\u0026") != -1) {
						let currentRoles = _this.currentRole.split("\u0026"),
							currentRolePicWidth = currentRoles.length == 2 ? "30%" : "25%";
						currentRoles.forEach(c => {
							$((_this.getDomIdByName(c.trim()) + 'Multi')).parent().css({
								"width": currentRolePicWidth
							});
							$((_this.getDomIdByName(c.trim()) + 'Multi')).fadeIn(200);
						});
					} else {
						$(_this.getDomIdByName(_this.currentRole)).fadeIn(200);
					}
					$('#nameBox').fadeTo(200, 1);
					$('#chatBox').fadeIn(200);
					_this.getLetterByLetter($('#chatBoxInner'));
					$("#reviewBtn").fadeIn();
					setTimeout(function() {
						_this.clickable = true;
					}, 1000);
				}, 500);
			} else if(this.step == 1) {
				this.clickable = false;
				this.step = 1.5;
				// 需要优化, 不是每一次都检查是否需要fade out
				// if($('#allPeople').is(":visible")){
				//
				//    $('#allPeople').fadeOut(0);
				//
				// }
				if(this.currentRole == '点评') {
					if(this.currentRole != this.nextRole) {
						this.chatBoxTeacherShow = false;
						$('#chatBoxTeacherInner').text("");
					}
					if(this.subNode < this.decisionTree[this.node].questions.length - 1) {
						this.subNode++;
						this.setCurrentComment();
					} else {
						this.step = 2;
						this.chatBoxTeacherShow = false;
						$('#chatBoxTeacherInner').text("");
					}
				} else if(this.currentRole == '旁白') {

					$('#voiceOver').fadeOut(0);
					$('#voiceOverInner').text("");
					if(this.subNode < this.decisionTree[this.node].questions.length - 1) {
						this.subNode++;
						this.setCurrentComment();
					} else {
						this.step = 2;
					}
				} else {

					if(this.currentRole != this.nextRole) {
						// 逗号: ff0c
						if(this.currentRole.indexOf("\u0026") != -1) {
							let currentRoles = _this.currentRole.split("\u0026");
							// 移出current roles
							currentRoles.forEach(c => {
								$((_this.getDomIdByName(c.trim()) + 'Multi')).parent().css({
									"width": 0
								});
								$((_this.getDomIdByName(c.trim()) + 'Multi')).fadeOut(0);
							});
						} else {
							$(this.getDomIdByName(this.currentRole)).fadeOut(0);
						}
						$('#nameBoxInner').fadeOut(0);
						$('#nameBoxInner').text("");

					}
					$('#chatBoxInner').fadeOut(0);
					$('#chatBoxInner').text("");
					if(this.subNode < this.decisionTree[this.node].questions.length - 1) {
						this.subNode++;
						this.setCurrentComment();
					} else {
						this.step = 2;
					}
					if(this.currentRole == '点评' || this.currentRole == '旁白' || this.step == 2) {
						$('#nameBox').fadeTo(200, 0);
						$('#chatBox').fadeOut(0);
					}
				}
				//对话时要先退出
				$('#nameBox').fadeTo(200, 0);
				$('#chatBox').fadeOut(200);
				// 过500ms后进行
				setTimeout(function() {
					if(_this.step == 1.5) {
						if(_this.currentRole == '点评') {
							if(_this.oldRole != '点评') {
								_this.chatBoxTeacherShow = true;
							}
							setTimeout(function() {
								$('#chatBoxTeacherInner').show();
								_this.getLetterByLetter($('#chatBoxTeacherInner'));
							}, 200);
						} else if(_this.currentRole == '旁白') {
							$('#voiceOver').fadeIn(200);
							_this.getLetterByLetter($('#voiceOverInner'));
						} else {
							// console.log(_this.oldRole);
							// console.log(_this.currentRole);
							if(_this.oldRole != _this.currentRole) {
								if(_this.currentRole.indexOf("\u0026") != -1) {
									let currentRoles = _this.currentRole.split("\u0026"),
										currentRolePicWidth = currentRoles.length == 2 ? "30%" : "25%";
									currentRoles.forEach(c => {
										$((_this.getDomIdByName(c.trim()) + 'Multi')).parent().css({
											"width": currentRolePicWidth
										});
										$((_this.getDomIdByName(c.trim()) + 'Multi')).fadeIn(200);
									});
								} else {
									$(_this.getDomIdByName(_this.currentRole)).fadeIn(200);
								}
								$('#nameBox').fadeTo(200, 1);
								$('#nameBoxInner').fadeIn(200);
								_this.showName($('#nameBoxInner'));
							}
							$('#nameBox').fadeTo(200, 1);
							$('#chatBox').fadeIn(200);
							$('#chatBoxInner').fadeIn(200);
							_this.getLetterByLetter($('#chatBoxInner'));
						}
						// 允许点击
						setTimeout(function() {
							_this.clickable = true;
						}, 1000);
					} else if(_this.step == 2) {
						$('#nameBox').fadeTo(200, 0);
						$('#chatBox').fadeOut(0);
						$('#chatBoxInner').hide();
						$('#nameBoxInner').hide();
						$('#nameBoxInner').text("");
						$('#chatBoxInner').text("");
						if(_this.currentNode.option.length > 0) {
							if(_this.firstOptionGuide) {
								$('#shade2').fadeIn();
								_this.firstOptionGuide = false;
							}
							_this.optionWrapShow = true;
							_this.clickable = false;
						} else {
							// $('#tipBox').fadeIn(200);
							$('#allPeople').fadeIn(200);
							_this.tipBoxShow = true;
							_this.apiService.ajax({
								'type': 'post',
								'url': '/api/multi',
								'data': {
									'multi_type_id': _this.typeId,
									'questions': _this.questionsSubmit,
									'answers': _this.answersSubmit
								}
							}).subscribe(result => {});
						}
					} // end of step == 2
				}, 500); // end of setTimeout
			} else if(this.step == 1.5) {
				this.clickable = false;
				this.step = 1;
				if(this.currentRole == '点评') {
					this.showFullText($('#chatBoxTeacherInner'));
				} else if(this.currentRole == '旁白') {
					this.showFullText($('#voiceOverInner'));
				} else {
					this.showFullText($('#chatBoxInner'));
				}
				setTimeout(function() {
					_this.clickable = true;
				}, 1000);
			} else if(this.step == 3) {
				this.clickable = false;
				this.step = 3.5;
				if(this.nextRole == '点评' || this.nextRole == '旁白') {
					$('#nameBoxInner').fadeOut(0);
					$('#nameBoxInner').text("");
					$('#nameBox').fadeTo(200, 0);
					$('#chatBox').fadeOut(0);
					$('#allPeople').fadeOut(0);
				}
				$('#chatBoxInner').fadeOut(0);
				$('#chatBoxInner').text("");
				$('#chatBoxTeacherInner').text("");
				$('#voiceOverInner').text("");
				setTimeout(function() {
					_this.setCurrentComment();
					if(_this.currentRole == '点评') {
						_this.chatBoxTeacherShow = true;
						setTimeout(function() {
							$('#chatBoxTeacherInner').show();
							_this.getLetterByLetter($('#chatBoxTeacherInner'));
						}, 200);
					} else if(_this.currentRole == '旁白') {
						$('#voiceOver').fadeIn(200);
						_this.getLetterByLetter($('#voiceOverInner'));
					} else {
						if(_this.currentRole != _this.oldRole) {
							// 如果有多个角色, 分开显示
							if(_this.currentRole.indexOf("\u0026") != -1) {
								let currentRoles = _this.currentRole.split("\u0026"),
									currentRolePicWidth = currentRoles.length == 2 ? "30%" : "25%";
								currentRoles.forEach(c => {
									$((_this.getDomIdByName(c.trim()) + 'Multi')).parent().css({
										"width": currentRolePicWidth
									});
									$((_this.getDomIdByName(c.trim()) + 'Multi')).fadeIn(200);
								});
							} else {
								$(_this.getDomIdByName(_this.currentRole)).fadeIn(200);
							}
							$('#nameBoxInner').fadeIn(200);
						}
						$('#chatBoxInner').fadeIn(200);
						_this.getLetterByLetter($('#chatBoxInner'));
					}
					setTimeout(function() {
						_this.clickable = true;
					}, 1000);
				}, 300); // end of setTimeout
			} else if(this.step == 3.5) {
				this.clickable = false;
				this.step = 1;
				if(this.currentRole == '点评') {
					this.showFullText($('#chatBoxTeacherInner'));
				} else if(this.currentRole == '旁白') {
					this.showFullText($('#voiceOverInner'));
				} else {
					this.showFullText($('#chatBoxInner'));
				}
				setTimeout(function() {
					_this.clickable = true;
				}, 1000); // end of set timeout
			} // end of step == 3.5
		} // end of if clickable
	} // end of screenClick

	setCurrentComment() {

		this.oldRole = this.currentRole;
		if(this.subNode < this.currentNode.questions.length - 1) {
			this.nextRole = this.currentNode.questions[this.subNode + 1].multi_role;
		} else {
			this.nextRole = "option";
		}
		this.conversation = this.currentNode.questions[this.subNode];
		this.currentRole = this.conversation.multi_role;
		this.currentComment = this.conversation.multi_description_comment;

		let temp = this.currentRole;
		if(temp == '点评') {
			temp = '导师点评';
		}
		this.conversationHistory.push({
			'role': temp,
			'comment': this.currentComment
		});

	} // end of setCurrentComment

	onOptionMouseDown(i, event) {

		if(this.optionClick == true || this.optionOnClick == true) {
			return false;
		}

		let _this = this,
		pressing = $(event.target).children('.pressing'), // 选项背景进度div
		pressingOption = pressing.children('.pressingOption'), // 选项背景进度div中的文字
		pressingWidth = $(event.target).width(), // 选项宽度
		pressingHeight = $(event.target).height(), // 选项高度
		pressingOuterHeight = $(event.target).outerHeight(), // 选项真实高度, 包括margin, padding
		pressingOffset = $(event.target).offset(); // 选项在屏幕的位置

		// 按选项少于0.45s, 则不响应
		this.optionClick = false;
		this.optionOnClick = true;
		// 设置选项动画参数
		pressingOption.width(pressingWidth);
		pressingOption.height(pressingHeight);
		pressing.width(0);
		pressing.height(pressingOuterHeight),
		pressing.show();
		pressing.offset({
			top: pressingOffset.top,
			left: pressingOffset.left
		});
    // 选项背景动画
    pressing.animate({
      width: $(event.target)[0].clientWidth
    }, this.type ? 300 : 500, 'linear');
		// 按中选项到达0.45s, 响应出现动画,  跳入下一个页面
		this.optionClickTimeout = setTimeout(function() {
			// 长按响应
			_this.optionClick = true;
			_this.nextNode = _this.currentNode.option[i].multi_option_next_question_id;
			_this.questionsSubmit.push(_this.currentNode.option[i].multi_question_id);
			_this.answersSubmit.push(_this.currentNode.option[i].multi_option_id);
			// 隐藏背景色
			pressing.animate({
				width: 0
			}, 1);
			pressing.hide();
			// 进入选中按钮动画
			$(event.target).addClass('optionLongPress');
			// 按键之后的动画
			$(event.target).find('.loading').fadeIn(200);
			// 隐藏文字
			_this.conversationHistory.push({
				'role': '我的选择',
				'comment': _this.currentNode.option[i].multi_option_comment
			});
			_this.currentNode.option[i].multi_option_comment = "";
			// 其他按钮的消失时间, 设置比选中按钮timeout时间长500ms, 维持按钮相对位置
			$('.option').not($(event.target)).fadeOut(2500);
			// 保持选中按钮动画2s, 跳转动画
			setTimeout(function() {

				// 移出按钮动画
				$(event.target).removeClass('optionLongPress');
				// 移出选项
				_this.optionWrapShow = false;
				// 移入人物场景对话
				$('#allPeople').fadeIn(200);
				$('#nameBox').fadeTo(200, 1);
				$('#chatBox').fadeIn(200);
				$('#nameBoxInner').fadeIn(200);
				$('#chatBoxInner').fadeIn(200);
				_this.step = 1.5;
				_this.optionClick = false;
				_this.subNode = 0;
				_this.node = _this.nextNode;
				_this.currentNode = _this.decisionTree[_this.node];
				_this.currentNode.option = _this.currentNode.option.sort(function(){
		            return 0.5 - Math.random();
		        });
				_this.setCurrentComment();
				_this.showName($('#nameBoxInner'));
				_this.getLetterByLetter($('#chatBoxInner'));
				setTimeout(function() {
					_this.clickable = true;
				}, 1000);
			}, 2000); // end of second setTimeout
		}, 450); // end of first setTimeout
	} //end of onOptionMouseDown

	onOptionMouseUp(event) {
    this.optionOnClick = true;
    setTimeout(()=>{
      this.optionOnClick = false;
    },300);
    // 如果已经触发按钮事件, 忽略放松按钮行为
    if (this.optionClick == true){
      return true;
    }
    let pressing = $(event.target).children('.pressing');
    // 调整宽度为0
    setTimeout(()=>{
      clearTimeout(this.optionClickTimeout);
      pressing.stop().animate({
        width: 0
      }, 300, 'linear');
    },this.type ? 300 : 0);

	} // end of onOptionMouseUp

	goBack() {
		let link = ['case-practice-team-begin', this.multiExerciseMetaId, this.learningPathId, this.practiceMetaId];
		let type = null
        this.route.queryParams.subscribe(queryParams=>{
            type = queryParams['type']
        })
        if(type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
        }else{
            this.router.navigate(link);
        }
	}

	getDomIdByName(name) {

		if(name == '季宁') {

			return '#blackPeople';

		} else if(name == '王立娜') {

			return '#purplePeople';

		} else if(name == '秦飞') {

			return '#bluePeople';

		} else if(name == '方科科') {

			return '#redPeople';

		} else if(name == '我' || name == '众人') {

			return '#allPeople';

		}

	} // end of getDomIdByName

	getLetterByLetter(container) {

		let _this = this;
		this.msgTimeout = setTimeout(function() {

			_this.msgCharacter++;
			var type = _this.currentComment.substring(0, _this.msgCharacter);
			container.text(type);
			_this.getLetterByLetter(container);
			if(_this.msgCharacter == _this.currentComment.length) {
				_this.step = 1;
				clearTimeout(_this.msgTimeout);
			}

		}, 30); // end of setTimeout

	} // end of getLetterByLetter

	showFullText(container) {
		clearTimeout(this.msgTimeout);
		container.text(this.currentComment);
	} // end of showFullText

	showName(container) {

		container.text(this.currentRole);

	} // end of showName

	reviewConversation($event) {
		$event.stopPropagation();
		$('#shade').fadeIn(50);
		// $('#reviewBox').fadeIn();
		this.reviewBoxShow = true;
		// console.log(this.reviewBoxShow);
		$('#closeBtn').fadeIn();
		this.clickable = false;
	}

	closeTip($event) {
		$event.stopPropagation();
		$('#shade').fadeOut();
		// $('#reviewBox').fadeOut();
		this.reviewBoxShow = false;
		$('#closeBtn').fadeOut();
		// 恢复点击功能
		this.clickable = true;
	}

	pressTipOut() {

		$('#shade2').fadeOut();
		$('#pressTipPic1').fadeOut();
		$('#pressTipText').fadeOut();
		$('#pressTipButton').fadeOut();
		this.apiService.ajax({
			'type': 'post',
			'url': '/sr/onceino/601',
			'data': {}
		}).subscribe(result => {

		});

	}

}



// WEBPACK FOOTER //
// ./src/app/case-practice-team-main/case-practice-team-main.component.ts